import { ReactNode } from 'react';
import { Interpolation, Theme } from '@emotion/react';
import { Icon, IconName } from '@frontend/icons';
import { Chip, FormRow, StatusSwitcherVariants, Text, usePopoverMenu } from '@frontend/design-system';
import { ChipRightElement } from '../../common';
import { chipStyle, labelContainerStyle, rowStyle } from './task-form.styles';

interface TaskFormRowProps {
  children?: ReactNode;
  label: string;
  icon: IconName;
  placeholder?: string;
  buttonIconName: IconName;
  value: string;
  getTriggerProps?: ReturnType<typeof usePopoverMenu<HTMLElement>>['getTriggerProps'];
  disabled?: boolean;
  variant?: StatusSwitcherVariants;
  isEditing?: boolean;
  leftElement?: React.ReactNode;
  // Keeping this type here because Chip component does not have a defined type for rightElement
  rightElement?: React.ReactNode;
  chipCss?: Interpolation<Theme>;
  onClickRemove?: () => void;
  isRemoveable?: boolean;
  trackingIds?: {
    chipButton?: string;
  };
  isButton?: boolean;
  onClick?: () => void;
}

export const TaskFormRow = ({
  children,
  label,
  icon,
  placeholder = '',
  buttonIconName,
  value,
  disabled = false,
  variant = 'default',
  trackingIds,
  leftElement,
  getTriggerProps,
  chipCss,
  onClickRemove,
  isRemoveable,
  isButton = true,
  ...rest
}: TaskFormRowProps) => {
  return (
    <FormRow css={rowStyle} cols={[35]}>
      <div css={labelContainerStyle}>
        <Icon name={icon} size={16} />
        <Text size='medium' weight='bold'>
          {label}
        </Text>
      </div>
      <Chip.StatusSwitcher
        disabled={disabled}
        variant={variant}
        leftElement={leftElement ?? <Icon name={buttonIconName} size={16} />}
        trackingId={trackingIds?.chipButton}
        css={[chipStyle, chipCss]}
        tooltipLabel={!isButton ? `Edit ${label}` : undefined}
        rightElement={
          <ChipRightElement
            isRemoveable={isRemoveable}
            onClickRemove={onClickRemove}
            value={value}
            showRightElement={isButton}
          />
        }
        {...getTriggerProps?.()}
        {...rest}
      >
        {value || placeholder}
      </Chip.StatusSwitcher>
      {children}
    </FormRow>
  );
};
